export const KEYS = {
  COMPARE: "COMPARE",
  PE_VALUATION_VIEW: "PE_VALUATION_VIEW",
  REVENUES_VIEW: "REVENUES_VIEW",
  GROSS_PROFIT_VIEW: "GROSS_PROFIT_VIEW",
  NET_PROFIT_VIEW: "NET_PROFIT_VIEW",
  GET_STOCKS: "GET_STOCKS",
  STOCK_DELETE: "STOCK_DELETE",
  GET_STOCK_MARKETS: "GET_STOCK_MARKETS",
  STOCK_MARKET_VIEW: "STOCK_MARKET_VIEW",
  STOCK_MARKET_ADD: "STOCK_MARKET_ADD",
  STOCK_MARKET_UPDATE: "STOCK_MARKET_UPDATE",
  STOCK_MARKET_DELETE: "STOCK_MARKET_DELETE",
  USER_MANAGEMENT_VIEW: "USER_MANAGEMENT_VIEW",
  APP_CONFIG_VIEW: "APP_CONFIG_VIEW",
  ENTITLEMENTS_VIEW: "ENTITLEMENTS_VIEW",
  SUBSCRIPTIONS_VIEW: "SUBSCRIPTIONS_VIEW",
  USERS_VIEW: "USERS_VIEW",

  SECTOR_VIEW: "SECTOR_VIEW",

  SECTOR_ADD: "SECTOR_ADD",

  SECTOR_UPDATE: "SECTOR_UPDATE",

  SECTOR_DELETE: "SECTOR_DELETE",

  COMPANY_QUARTERS_ADD: "COMPANY_QUARTERS_ADD",

  COMPANY_QUARTERS_VIEW: "COMPANY_QUARTERS_VIEW",

  COMPANY_QUARTERS_UPDATE: "COMPANY_QUARTERS_UPDATE",

  COMPANY_QUARTERS_DELETE: "COMPANY_QUARTERS_DELETE",

  METRICS_VIEW: "METRICS_VIEW",

  METRICS_ADD: "METRICS_ADD",

  METRICS_UPDATE: "METRICS_UPDATE",

  METRICS_DATA_VIEW: "METRICS_DATA_VIEW",

  METRICS_DATA_UPDATE: "METRICS_DATA_UPDATE",

  METRICS_DELETE: "METRICS_DELETE",

  STOCK_MARKET_BULK_UPLOAD: "STOCK_MARKET_BULK_UPLOAD",

  SECTOR_BULK_UPLOAD: "SECTOR_BULK_UPLOAD",

  COMPANY_QUARTER_BULK_UPLOAD: "COMPANY_QUARTER_BULK_UPLOAD",

  STOCK_BULK_UPLOAD: "STOCK_BULK_UPLOAD",

  GROSS_PROFIT_BULK_UPLOAD: "GROSS_PROFIT_BULK_UPLOAD",

  NET_PROFIT_BULK_UPLOAD: "NET_PROFIT_BULK_UPLOAD",

  REVENUE_BULK_UPLOAD: "REVENUE_BULK_UPLOAD",

  PE_VALUATION_BULK_UPLOAD: "PE_VALUATION_BULK_UPLOAD",

  METRICS_BULK_UPLOAD: "METRICS_BULK_UPLOAD",

  GET_USERS: "GET_USERS",

  GET_ROLES: "GET_ROLES",

  GET_ALL_STOCKS: "GET_ALL_STOCKS",

  EQUATIONS_VIEW: "EQUATIONS_VIEW",

  GET_PERMISSIONS: "GET_PERMISSIONS",

  GET_PERMISSION_ROLE: "GET_PERMISSION_ROLE",

  UPDATE_ROLE_PERMISSIONS: "UPDATE_ROLE_PERMISSIONS",

  EQUATIONS_ADD: "EQUATIONS_ADD",

  EQUATIONS_UPDATE: "EQUATIONS_UPDATE",

  EQUATIONS_DELETE: "EQUATIONS_DELETE",

  GET_ROLE: "GET_ROLE",

  ADD_ROLE_PERMISSION: "ADD_ROLE_PERMISSION",

  DELETE_ROLE: "DELETE_ROLE",
  DYNAMIC_GRAPHS: "DYNAMIC_GRAPHS",
  SETTINGS: "SETTINGS",
  AD_MANAGEMENT: "AD_MANAGEMENT",
  GRAPH_EDITOR: "GRAPH_EDITOR",
  MY_PROFILE: "MY_PROFILE",
  SHOW_COMPANY_PROFILE: "SHOW_COMPANY_PROFILE",
  VIEW_DYNAMIC_GRAPH: "VIEW_DYNAMIC_GRAPH",
  SAVE_DYNAMIC_GRAPH: "SAVE_DYNAMIC_GRAPH",
  ENABLE_DYNAMIC_GRAPH_7_YEAR_PERIOD: "ENABLE_DYNAMIC_GRAPH_7_YEAR_PERIOD",
  ENABLE_DYNAMIC_GRAPH_10_YEAR_PERIOD: "ENABLE_DYNAMIC_GRAPH_10_YEAR_PERIOD",
  STOCK_SCREENER_VIEW: "STOCK_SCREENER_VIEW",
  AI_RECOMMENDATION_VIEW: "AI_RECOMMENDATION_VIEW",
  EXPORT_TABLE_OPTION: "EXPORT_TABLE_OPTION",
  WATCHLIST_VIEW: "WATCHLIST_VIEW",
  SUPPORT_VIEW: "SUPPORT_VIEW",
  FINANCIAL_VIEW: "FINANCIAL_VIEW",
  ANNUAL_REPORT_ENTRY_VIEW: "ANNUAL_REPORT_ENTRY_VIEW",
  STOCK_ASSISTANT_VIEW: "STOCK_ASSISTANT_VIEW",
  STOCK_CHATBOT_VIEW: "STOCK_CHATBOT_VIEW",
  MARKET_HEATMAP_VIEW: "MARKET_HEATMAP_VIEW",
  TECHNICAL_ANALYSIS_VIEW: "TECHNICAL_ANALYSIS_VIEW",
  FALCON_DATA_ENTRY_VIEW: "FALCON_DATA_ENTRY_VIEW",
  FALCON_EXTRACTION_VIEW: "FALCON_EXTRACTION_VIEW",
  FALCON_SENIOR_QC_VIEW: "FALCON_SENIOR_QC_VIEW",
  SINGLE_STOCK_ANALYSIS_VIEW: "SINGLE_STOCK_ANALYSIS_VIEW",
  BEGINNER_ANALYSIS_VIEW: "BEGINNER_ANALYSIS_VIEW",
  FALCON_LOG_MONITOR_VIEW: "FALCON_LOG_MONITOR_VIEW",
};
